import { render } from "./SyncProductStockRackBeat.vue?vue&type=template&id=4ed5b53a&scoped=true&ts=true"
import script from "./SyncProductStockRackBeat.vue?vue&type=script&lang=ts"
export * from "./SyncProductStockRackBeat.vue?vue&type=script&lang=ts"

import "./SyncProductStockRackBeat.vue?vue&type=style&index=0&id=4ed5b53a&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed5b53a"]])

export default __exports__